import Map from 'ol/Map';
import View from 'ol/View';
import OSM from 'ol/source/OSM';
import TileLayer from 'ol/layer/Tile';
import TileWMS from 'ol/source/TileWMS';
import XYZ from 'ol/source/XYZ';
import { ScaleLine, defaults as defaultControls } from 'ol/control';
import LayerGroup from 'ol/layer/Group';
import LayerSwitcher from 'ol-layerswitcher';
import KML from 'ol/format/KML';
import { Vector as VectorLayer } from 'ol/layer';
import VectorSource from 'ol/source/Vector';
import { Fill, Stroke, Style } from 'ol/style';

let map;
let maxZoom = 17;
let minZoom = 0;
let proj = 'EPSG:4326';
let showDownload = (typeof window.enableDownload === 'undefined') ? false : window.enableDownload;

const kR = 'PALETTE_INDEX';
const kG = 'ALPHA_BAND';
const kB = 'ALPHA_BAND_Band2';
const URL_TILE_ARCHIVE = 'https://worldcover2020.esa.int/data/archive/';

var infoTimer;

const LAYER_FEATURES = [
  { 'id': '0_0_0', 'land_class': 'No data' },
  { 'id': '0_100_0', 'land_class': 'Tree cover' },
  { 'id': '255_187_34', 'land_class': 'Shrubland' },
  { 'id': '255_255_76', 'land_class': 'Grassland' },
  { 'id': '240_150_255', 'land_class': 'Cropland' },
  { 'id': '250_0_0', 'land_class': 'Built-up' },
  { 'id': '180_180_180', 'land_class': 'Bare / sparse vegetation' },
  { 'id': '240_240_240', 'land_class': 'Snow and Ice' },
  { 'id': '0_100_200', 'land_class': 'Permanent water bodies' },
  { 'id': '0_150_160', 'land_class': 'Herbaceous wetland' },
  { 'id': '0_207_117', 'land_class': 'Mangrove' },
  { 'id': '250_230_160', 'land_class': 'Moss and lichen' }
];

const styleFunction = function (feature) {
  const opacity = 0.45;

  return new Style({
    fill: new Fill({
      color: [0xF0, 0xF0, 0xF0, opacity],
    }),
    stroke: new Stroke({
      color: '#003247',
      width: 2,
    }),
  });
};

let baseUrl = "https://worldcover2020.esa.int/geoserver/gwc/service/wms";

const wmsSource = new TileWMS({
  isBaseLayer: false,
  transparent: true,
  attributions: ['&copy; ESA WorldCover project 2020 / Contains modified Copernicus Sentinel data (2020) processed by ESA WorldCover consortium'],
  url: baseUrl,
  serverType: 'geoserver',
  projection: proj,
  params: {
    'LAYERS': 'esa_worldcover2020:tiles',
    'FORMAT': 'image/png',
    'TRANSPARENT': 'true',
    'VERSION': '1.1.1',
    'WIDTH': '256',
    'HEIGHT': '256',
    'SRS': proj,
    tiled: true,
  },
});

window.getMapImage = function () {
  // show loader
  $("#site-loader").removeClass('d-none').addClass('d-block');

  // map layer
  map.once('rendercomplete', function () {
    const mapCanvas = document.createElement('canvas');
    const size = map.getSize();
    mapCanvas.width = size[0];
    mapCanvas.height = size[1];

    const ctx = mapCanvas.getContext('2d');

    Array.prototype.forEach.call(
      document.querySelectorAll('.ol-layer canvas'),
      function (canvas) {
        if (canvas.width > 0) {
          const opacity = canvas.parentNode.style.opacity;
          ctx.globalAlpha = opacity === '' ? 1 : Number(opacity);
          const transform = canvas.style.transform;
          // Get the transform parameters from the style's transform matrix
          const matrix = transform
            .match(/^matrix\(([^\(]*)\)$/)[1]
            .split(',')
            .map(Number);
          // Apply the transform to the export map context
          CanvasRenderingContext2D.prototype.setTransform.apply(
            ctx,
            matrix
          );
          ctx.drawImage(canvas, 0, 0);
        }
      }
    );

    // add text
    let txt = "© ESA WorldCover project 2020 / Contains modified Copernicus Sentinel data (2020) processed by ESA WorldCover consortium";
    let txtX = mapCanvas.width - 20;
    let txtY = mapCanvas.height - 14;

    ctx.font = "12px Open Sans";
    ctx.textAlign = "right";

    let txtWidth = ctx.measureText(txt).width;
    ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';
    ctx.fillRect(txtX-txtWidth-5, txtY-12, txtWidth+10, 17);

    ctx.fillStyle = "black";
    ctx.fillText(txt, txtX, txtY);

    // add logo
    let logoW = 178;
    let logoH = 55;
    let logoX = mapCanvas.width - 20 - logoW;
    let logoY = 20;
    ctx.drawImage(document.getElementById('wt-image'), logoX, logoY, logoW, logoH);

    if (navigator.msSaveBlob) {
      // link download attribute does not work on MS browsers
      navigator.msSaveBlob(mapCanvas.msToBlob(), 'esa-worldcover2020-image.png');
    } else {
      const aLink = document.createElement('a');
      aLink.download = 'esa-worldcover2020-image.png';
      aLink.href = mapCanvas.toDataURL();
      aLink.click();
      aLink.delete;
    }
  });
  map.renderSync();

  // hide loaders
  setTimeout(function () { $("#site-loader").removeClass('d-block').addClass('d-none'); }, 3000);
};

function init() {

  let worldCoverTile = new TileLayer({
    title: 'ESA WorldCover 2020',
    maxZoom: maxZoom,
    minZoom: minZoom,
    source: wmsSource,
  });

  let osm = new TileLayer({
    title: 'OpenStreetMap',
    type: 'base',
    visible: true,
    maxZoom: maxZoom,
    minZoom: minZoom,
    source: new OSM()
  });

  let gSat = new TileLayer({
    title: 'Google Satellite',
    type: 'base',
    visible: false,
    source: new XYZ({
      url: 'https://mt0.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
      maxZoom: maxZoom,
      minZoom: minZoom,
      attributions: ['&copy; <a href="https://www.google.com/intl/en_nl/help/terms_maps.html">Google</a>'],
    })
  });

  let gMap = new TileLayer({
    title: 'Google Maps',
    type: 'base',
    visible: false,
    source: new XYZ({
      url: 'https://mt1.google.com/vt/lyrs=r&x={x}&y={y}&z={z}',
      maxZoom: maxZoom,
      minZoom: minZoom,
      attributions: ['&copy; <a href="https://www.google.com/intl/en_nl/help/terms_maps.html">Google</a>'],
    })
  });

  const baseMaps = new LayerGroup({
    title: 'Base maps',
    layers: [osm, gSat, gMap]
  });

  let arrayOverlays = [worldCoverTile];

  if (showDownload) {
    const vector = new VectorLayer({
      title: 'Product name',
      visible: true,
      style: styleFunction,
      source: new VectorSource({
        url: 'data/kml/ESA_WorldCover_10m_2020.kml',
        format: new KML({
          extractStyles: false,
        }),
      }),
    });

    arrayOverlays.push(vector);
  }

  const overlays = new LayerGroup({
    title: 'Overlays',
    layers: arrayOverlays
  });

  map = new Map({
    target: 'fp-custom-map-ol',
    layers: [baseMaps, overlays],
    pixelRatio: 1,
    view: new View({
      center: [0, 0],
      projection: proj,
      zoom: minZoom,
      maxZoom: maxZoom,
      minZoom: minZoom,
    }),
    controls: defaultControls().extend([
      new ScaleLine({
        units: 'metric',
      }),
    ]),
  });

  const layerSwitcher = new LayerSwitcher({
    reverse: false,
    groupSelectStyle: 'group'
  });
  map.addControl(layerSwitcher);

  const displayFeatureInfo = function (pixel) {
    info.css({
      left: pixel[0] + 'px',
      top: pixel[1] - 15 + 'px',
    });

    const feature = map.forEachFeatureAtPixel(pixel, function (feature) {
      return feature;
    });

    if (feature) {
      info.attr('data-original-title', feature.get('name') + '.zip').tooltip('show');
    } else {
      info.tooltip('hide');
    }
  };

  const info = $('#info');
  info.tooltip({
    animation: false,
    trigger: 'manual',
  });

  map.on('pointermove', function (evt) {
    if (evt.dragging) {
      info.tooltip('hide');
      return;
    }
    stopInfoTimer();
    displayFeatureInfo(map.getEventPixel(evt.originalEvent));
    infoTimer = setTimeout(function(){ info.tooltip('hide'); }, 2000);
  });

  map.on('singleclick', function (evt) {
    if (showDownload) {
      downloadTile(evt);
    } else {
      showPixelFeatureInfo(evt);
    }
  });

  $("#btn-save-map-image").on('click', getMapImage);
}

function stopInfoTimer()
{
  clearTimeout(infoTimer);
}

function showPixelFeatureInfo(evt) {
  document.getElementById('info-feature').innerHTML = '';
  const viewResolution = map.getView().getResolution();

  const url = wmsSource.getFeatureInfoUrl(
    evt.coordinate,
    viewResolution,
    proj,
    { 'INFO_FORMAT': 'application/json' }
  );

  if (url) {
    fetch(url)
      .then(response => response.json())
      .then(data => {
        if (data["features"]) {
          let prop = data["features"][0];
          if (prop["properties"]) {
            let feat = prop["properties"][kR] + "_" + prop["properties"][kG] + "_" + prop["properties"][kB];
            let layer_class = LAYER_FEATURES.find(x => x.id == feat).land_class;

            document.getElementById('info-box').classList.remove("hidden");
            document.getElementById('info-feature').innerHTML = '<p>Point: ' + evt.coordinate[1] + ', ' + evt.coordinate[0] + '<br>Land cover class: ' + layer_class + '</p>';
          } else {
            // TODO: show no data
          }
        } else {
          // TODO: show no data
        }
      });
  }
}

function downloadTile(evt) {
  let pixel = map.getEventPixel(evt.originalEvent);

  const feature = map.forEachFeatureAtPixel(pixel, function (feature) {
    return feature;
  });

  if (feature) {
    let filename = feature.get('name') + '.zip';
    let url = URL_TILE_ARCHIVE + filename;
    _paq.push(['trackEvent', 'Downloads', 'Map Tile Download Click', filename]);
    window.open(url, '_blank').focus();
  }
}

if ($("#fp-custom-map-ol").length) {
  $.ajaxSetup({
    headers: {
      'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
  });

  init();
}
